<form (ngSubmit)="onSubmit()" [formGroup]="formGroup" #form="ngForm">
  <div class="row mt-2">
    <div class="col">
      <mat-form-field>
        <mat-label>{{ "forms.landingSettings.labels.presentation" | translate }}</mat-label>
        <mat-select formControlName="presentation" required>
          <mat-option [value]="false">{{ "forms.general.labels.no" | translate }}</mat-option>
          <mat-option [value]="true">{{ "forms.general.labels.yes" | translate }}</mat-option>
        </mat-select>
        <mat-error>{{ getError("presentation") }}</mat-error>
      </mat-form-field>
    </div>
  </div>
  <div *ngIf="withSubmit" class="row justify-content-end mt-2">
    <div class="col-md-auto">
      <button mat-raised-button [appButtonLoading]="formLoading.loading" color="primary">
        {{ submitText | translate }}
      </button>
    </div>
  </div>
</form>
